import type { StnStatus } from '@api/warehouse-ops';
import type { FC } from 'react';

import { StatusBadge, type StatusStyle } from '../../procurementOrders/shared';

import { STATUS_LABEL } from './stnLabels';

/**
 * Same chip as the Purchase Orders, Shipments and Payments grids, in their muted palette:
 * slate while nothing has moved, indigo / purple / blue as the transfer progresses, the
 * Purchase Orders green once received, muted red when cancelled.
 */
const STATUS_TONE: Record<StnStatus, Omit<StatusStyle, 'label'>> = {
    DRAFT: { color: 'rgb(100, 116, 139)', bg: 'rgba(100, 116, 139, 0.12)' },
    APPROVED: { color: 'rgb(79, 70, 229)', bg: 'rgba(99, 102, 241, 0.16)' },
    DISPATCHED: { color: 'rgb(124, 95, 240)', bg: 'rgba(144, 117, 255, 0.16)' },
    IN_TRANSIT: { color: 'rgb(1, 149, 255)', bg: 'rgba(1, 149, 255, 0.12)' },
    RECEIVED: { color: 'rgb(45, 187, 136)', bg: 'rgba(45, 187, 136, 0.14)' },
    CANCELLED: { color: 'rgb(205, 101, 101)', bg: 'rgba(205, 101, 101, 0.12)' },
};

const StnStatusBadge: FC<{ status: StnStatus; label?: string | null }> = ({ status, label }) => (
    <StatusBadge
        status={status}
        styleOverride={{ ...STATUS_TONE[status], label: label ?? STATUS_LABEL[status] }}
    />
);

export default StnStatusBadge;
